//todo - wrap in factory
export let pagination = {
  count: 0,
  total: 0,
  current_page: 0,
  total_pages: 0,
  per_page: 0
}

export let company = () => {
  let company = {
    name: null,
    email_support: null,
    billing_options: [],
    documents: []
  }

  return Object.assign({}, company)
}

export let contract = () => {
  let contract = {
    uuid: null,
    company: company()
  }

  return Object.assign({}, contract)
}

//todo - replace with order()
export let orderTemplate = {
  uuid: null,
  code: null,
  sum: null,
  duration: null,
  contract: contract()
}

export let order = () => {
  let order = {
    uuid: null,
    code: null,
    sum: null,
    duration: null,
    contract: contract()
  }

  return JSON.parse(JSON.stringify(order))
}

export let invoice = () => {
  let invoice = {
    uuid: null,
    total_sum_without_tax: null,
    from: null,
    to: null,
    created_at: null,
    due_date: null,
  }

  return JSON.parse(JSON.stringify(invoice))
}

export let affiliate = () => {
  let affiliate = {
    uuid: null,
    name: null,
    button_color: null,
    background_color: null,
    active: false,
    created_at: null,
  }

  return Object.assign({}, affiliate)
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/services/dataTemplates.js